import type { components } from '@/api/schema';
import type { DestinoSubida, TipoArchivo } from '@/lib/archivos';

import type { TipoNota } from './comun/queries';

/** Rutas de la API de cada tipo simple (`/admin/<clave>`). */
export type ClaveSimple = 'videos' | 'live-recordings' | 'flashcards' | 'gpc-guides' | 'pdfs';

export interface ItemSimpleDe {
  videos: components['schemas']['VideoItem'];
  'live-recordings': components['schemas']['LiveRecordingItem'];
  flashcards: components['schemas']['FlashcardItem'];
  'gpc-guides': components['schemas']['GpcGuideItem'];
  pdfs: components['schemas']['PdfItem'];
}
export type ItemSimple = ItemSimpleDe[ClaveSimple];

export interface TipoSimple {
  clave: ClaveSimple;
  titulo: string;
  nombreMax: number;
  /** Notas y casos ligados (solo video y flashcard). */
  notas?: TipoNota;
  /** Archivo propio: destino de subida y formatos. */
  archivo?: { destino: DestinoSubida; tipos: TipoArchivo[] };
  masivo?: boolean;
  sinEspecialidad?: boolean;
}

/** `library_items.type` de los tipos simples → su editor en modal. */
export const SIMPLES: Record<string, TipoSimple> = {
  video: { clave: 'videos', titulo: 'Video tip', nombreMax: 100, notas: 'video' },
  'video-live': { clave: 'live-recordings', titulo: 'Grabación de clase en vivo', nombreMax: 100 },
  flashcard: {
    clave: 'flashcards',
    titulo: 'Flashcard',
    nombreMax: 120,
    notas: 'flashcard',
    archivo: { destino: 'flashcard', tipos: ['image'] },
    masivo: true,
  },
  'guia-gpc': {
    clave: 'gpc-guides',
    titulo: 'Guía GPC',
    nombreMax: 250,
    archivo: { destino: 'guia-gpc', tipos: ['image', 'pdf'] },
    masivo: true,
  },
  pdf: {
    clave: 'pdfs',
    titulo: 'PDF',
    nombreMax: 50,
    archivo: { destino: 'pdf', tipos: ['pdf'] },
    sinEspecialidad: true,
  },
};

/** Tipos compuestos: pantalla propia (`detailId` = id del registro del tipo). */
export function rutaCompuesto(type: string, detailId: number): string | null {
  switch (type) {
    case 'presentacion':
      return `/contenido/presentaciones/${detailId}`;
    case 'manual':
    case 'manual-av':
      return `/contenido/manuales/${detailId}`;
    case 'resumengpc':
      return `/contenido/resumenes-gpc/${detailId}`;
    case 'clase':
      return `/contenido/clases/${detailId}`;
    case 'examen':
      return `/preguntas/examenes/${detailId}`;
    default:
      return null;
  }
}

export interface OpcionNuevo {
  tipo: string;
  etiqueta: string;
  masivo?: boolean;
}

/** Tipos que se crean en un modal; los compuestos abren un alta corta y luego su pantalla. */
export const OPCIONES_SIMPLES: OpcionNuevo[] = [
  { tipo: 'video', etiqueta: 'Video tip' },
  { tipo: 'video-live', etiqueta: 'Grabación de clase en vivo' },
  { tipo: 'flashcard', etiqueta: 'Flashcards (varias)', masivo: true },
  { tipo: 'guia-gpc', etiqueta: 'Guías GPC (varias)', masivo: true },
  { tipo: 'pdf', etiqueta: 'PDF' },
];

/** Tipos compuestos que se crean desde «Nuevo» (alta corta y luego su pantalla). */
export const OPCIONES_COMPUESTAS: OpcionNuevo[] = [
  { tipo: 'clase', etiqueta: 'Clase' },
  { tipo: 'presentacion', etiqueta: 'Presentación' },
];
